import { HelmetDexteel } from "@dexteel/mesf-core";
import { FirstTurnedRollsReport } from "./components/FirstTurnedRollsReport";

export const FirstTurnedRollsPage = () => {
	return (
		<>
			<HelmetDexteel title="First Turned Rolls" />
			<FirstTurnedRollsReport />
		</>
	);
};
